import _ from 'lodash';

function ListSalesController($stateParams, $filter, $window, Auth, SidebarService, SaleComponent, ValidationService, TicketComponent, PageHeading, Toast) {
	'ngInject';

	const vm = this;
	vm.fetchTickets = fetchTickets;
	vm.getTickets = SaleComponent.getTickets;
	vm.paginationInfo = SaleComponent.getPaginationInfo;
	vm.numberValidation = ValidationService.numberValidation;
	vm.ticketNumber = '';
	vm.searchParams = $stateParams.params;
	vm.clearDate = clearDate;
	vm.reviewTicket = reviewTicket;

	if ($stateParams.params) {
		fetchTickets($stateParams.params, $stateParams.page);
	}

	activate();

	function activate() {
		const heading = $filter('translate')('SIDEBAR.SALES');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.SALES')}`;

		PageHeading.setPageHeading(heading, title);
		SaleComponent.clearTickets();

		SidebarService.getCurrentUserRoles()
			.then(function(roles) {
				vm.isOwnerOrAdministrator = _.find(roles, {'name': 'owner'}) || _.find(roles, {'name': 'administrator'});
				vm.isOffice = _.find(roles, {'name': 'office'});
				
			});
	}

	function clearDate() {
		vm.searchParams.date = null;
	}

	function fetchTickets(searchParams, page) {
		SaleComponent.fetchTickets(searchParams, page)
			.then(function(response) {
				if (response.errors) {
					Toast.responseError(response.errors);
				}
			});
	}

	function reviewTicket(ticket, searchParams) {
		const params = {
			'review_message': ticket.review_message
		};
		let successMessage = '';

		if (ticket.action === 'inspect') {
			params.review = ticket.inspected ? 'inspected' : 'default';
			successMessage = 'SUCCESS.UPDATE_TICKET';
		} else if (ticket.action === 'cancel') {
			if ($window.confirm($filter('translate')('CONFIRM.CANCEL_TICKET'))) {
				params.review = 'canceled';
				successMessage = 'SUCCESS.CANCELED_TICKET';
			} else {
				return false;
			}
		}

		TicketComponent.reviewTicket(ticket.id, params)
			.then(function(res) {
				if (res.errors) {
					Toast.responseError(res.errors);
				} else {
					Toast.success($filter('translate')(successMessage));
					fetchTickets(searchParams, SaleComponent.getPaginationInfo().page);
				}
			});
	}

}

export default ListSalesController;



/** WEBPACK FOOTER **
 ** ./client/private/sales/list/list.controller.js
 **/